import DetailsIcon from '@mui/icons-material/Info';
import DashboardIcon from '@mui/icons-material/InsertChart';
import { FC } from 'react';
import { NumberField, TextField, useGetIdentity, WithRecord } from 'react-admin';

import { GetDistributorDetailsResponse } from '@Common/types/bo_external/distributor/details';

import {
  ShowFields,
  ShowSection,
  ShowWithNavigation,
  VerticalTab,
  VerticalTabsLayout,
} from '@sh4res/bo-common/components';
import { UTCDateField } from '@sh4res/bo-common/fields';

import { DistributorDashboard } from '@Resources/distributor/dashboard/DistributorDashboard';

export const DistributorList: FC = () => {
  const testId = 'BoExternalDistributorList';
  const { data } = useGetIdentity();
  if (!data) {
    return;
  }
  return (
    <ShowWithNavigation
      id={data.id}
      hideBackBtn
      actions={false}
      avatar={{ name_source: 'name', image_source: 'logo_url' }}
      title={
        <WithRecord
          render={(record: GetDistributorDetailsResponse) =>
            `${record.firstname} ${record.lastname}`
          }
        />
      }
      sx={{ height: '100%' }}>
      <VerticalTabsLayout>
        <VerticalTab
          icon={<DashboardIcon />}
          label="resources.distributor.sub_titles.dashboard"
          sx={{ textTransform: 'none' }}
          path="dashboard">
          <DistributorDashboard />
        </VerticalTab>
        <VerticalTab
          icon={<DetailsIcon />}
          label="resources.distributor.sub_titles.details"
          path="details">
          <ShowSection label="general.sections.details">
            <ShowFields<GetDistributorDetailsResponse>
              fields={{
                id: <NumberField data-testid={`${testId}_IdField`} />,
                firstname: <TextField data-testid={`${testId}_FirstnameField`} />,
                lastname: <TextField data-testid={`${testId}_LastnameField`} />,
                orias_code: <TextField data-testid={`${testId}_OriasCodeField`} />,
                email: <TextField data-testid={`${testId}_EmailField`} />,
                landline: <TextField data-testid={`${testId}_LandlineField`} />,
                phone_number: <TextField data-testid={`${testId}_PhoneNumberField`} />,
                collective_inspector_email: (
                  <TextField data-testid={`${testId}_CollectiveInspectorEmailField`} />
                ),
                created_at: <UTCDateField data-testid={`${testId}_CreatedAtField`} />,
              }}
            />
          </ShowSection>
          <ShowSection label="resources.distributor.sub_titles.address">
            <ShowFields<GetDistributorDetailsResponse>
              fields={{
                street: <TextField data-testid={`${testId}_StreetField`} />,
                postal_code: <TextField data-testid={`${testId}_PostalCodeField`} />,
                city: <TextField data-testid={`${testId}_CityField`} />,
                country_code: <TextField data-testid={`${testId}_CountryCodeField`} />,
              }}
            />
          </ShowSection>
        </VerticalTab>
      </VerticalTabsLayout>
    </ShowWithNavigation>
  );
};
